<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      title="更换手机号"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>
    <div class="page">
      <div v-show="!isSuccess">
        <van-field
          label="新手机号"
          v-model="form.field.mobile"
          type="tel"
          maxlength="11"
          clearable
          placeholder="请输入您的新手机号" />
        <van-field
          label="验证码"
          v-model="form.field.loginCode"
          type="number"
          maxlength="6"
          clearable
          placeholder="请输入6位验证码">
          <van-button
            :loading="smsForm.loading"
            loading-text="发送中..."
            @click="onSMSSend"
            plain
            :disabled="smsForm.isSendSMSEnable"
            slot="button"
            size="small"
            type="danger"
            >{{ getSendBtnText }}</van-button
          >
        </van-field>
        <van-cell class="mt-50">
          <van-button
            type="danger"
            @click="editMobile"
            round
            size="large"
            :loading="form.loading"
            >确认</van-button
          >
        </van-cell>
      </div>
      <div v-show="isSuccess">
        <div class="pt-50 ta-c">
          <img src="@/assets/img/change-phone/icon.png" style="width: 40%" />
          <div class="fs-20">更新成功</div>
          <div class="mt-10 fs-16">下次登录时请使用新手机号码登录！</div>
        </div>
        <div class="ta-c px-20 mt-30">
          <van-button
            type="danger"
            round
            size="large"
            @click="$router.replace({ name: 'user' })"
            >我知道了</van-button
          >
        </div>
      </div>
    </div>
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide
      ref="slideblock"
      @success="onSlideSuccess"
      sliderText="向右滑"
      :show="false"
      :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>

<script>
import PhotoSlide from "../../components/photoSlide.vue"
import { Button, Field, NavBar, Toast, Dialog, Cell } from "vant"
import * as CustApi from "@/api/cust"
import * as validate from "@/utils/validate"

export default {
  name: "index",
  data: () => ({
    isSuccess: false,
    showSlidePop: false, // 是否显示滑块解锁框
    smsForm: {
      loading: false,
      smsCountDown: 0,
      smsInterval: null,
      isSendSMSEnable: false
    },
    form: {
      loading: false,
      field: {
        mobile: "",
        loginCode: ""
      }
    }
  }),
  computed: {
    isSendSMSEnable() {
      return this.smsForm.smsCountDown !== 0
    },
    getSendBtnText() {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown
      } else {
        return "获取验证码"
      }
    }
  },
  methods: {
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.$refs.slideblock.reset()
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.smsForm.loading = true
      CustApi.sendcode(this.form.field.mobile)
        .then((data) => {
          this.smsForm.loading = false
          this.startSMSTimer()
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },
    onSMSSend() {
      if (!validate.mobile(this.form.field.mobile)) {
        Toast("手机号码不正确")
        return
      }
      this.showSlidePop = true
    },
    editMobile() {
      if (!validate.mobile(this.form.field.mobile)) {
        Toast("手机号码不正确")
        return
      }
      if (
        !validate.num(this.form.field.loginCode) ||
        this.form.field.loginCode.length != 6
      ) {
        Toast("验证码不正确")
        return
      }
      this.form.loading = true
      CustApi.editMobile(this.form.field)
        .then((data) => {
          this.form.loading = false
          this.isSuccess = true
        })
        .catch((e) => {
          this.form.loading = false
          console.debug(e)
          if (e && e.msg) {
            Toast(e.msg)
          }
        })
    },
    startSMSTimer() {
      this.smsForm.smsCountDown = 60
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--
        if (this.smsForm.smsCountDown <= 0) {
          clearInterval(this.smsForm.smsInterval)
        }
      }, 1000)
    }
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Cell.name]: Cell,
    PhotoSlide
  }
}
</script>

<style scoped>
</style>